module.exports = __webpack_public_path__ + "img/logoNewDark.d71f017b.png";